import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {OpenEndedQuestionEditStore} from './OpenEndedQuestionEditStore';
import {openEndedQuestionEditStoreRenderer} from './openEndedQuestionEditStoreRenderer';

@observer
export class OpenEndedQuestionInlineCreate
  extends React.Component<{ store: AddContentStore }> {
  readonly store: OpenEndedQuestionEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new OpenEndedQuestionEditStore();
    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        () => this.props.store.setValid(this.store.valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Content,
        () => this.props.store.setContents(this.store.x9Content),
        {fireImmediately: true}
      ));
  }

  render() {
    return Array.from(openEndedQuestionEditStoreRenderer(this.store));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
